module.exports = __webpack_public_path__ + "img/biter-attack-2.2de5be6c.png";